var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 27,
    viewBox: "0 0 39 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0H2.00004C0.899971 0 0 0.923047 0 2.05125V24.6154C0 25.7435 0.899971 26.6667 2.00004 26.6667H37C38.1 26.6667 39.0001 25.7437 39.0001 24.6154V2.05125C39 0.923047 38.1 0 37 0ZM36.2494 1.53836L20.6505 13.5385C20.37 13.7574 19.9395 13.8944 19.4999 13.8923C19.0604 13.8944 18.63 13.7574 18.3494 13.5385L2.75049 1.53836H36.2494ZM27.917 14.3303L36.417 25.0996C36.4255 25.1104 36.436 25.1186 36.445 25.1284H2.55496C2.56395 25.1181 2.57446 25.1104 2.58299 25.0996L11.083 14.3303C11.3434 14.0001 11.2941 13.5159 10.9715 13.2482C10.6495 12.9811 10.1775 13.0317 9.91697 13.362L1.49998 24.0262V2.49992L17.4499 14.7691C18.0495 15.2271 18.7789 15.4287 19.4998 15.4307C20.2198 15.4291 20.9499 15.2276 21.5498 14.7691L37.4997 2.49992V24.026L29.083 13.362C28.8224 13.0318 28.35 12.981 28.0284 13.2482C27.7059 13.5153 27.6564 14.0001 27.917 14.3303Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup17);
export default __webpack_public_path__ + "static/media/Group-17.71b74bad68b89ab9876909ffe41d9e1e.svg";
export { ForwardRef as ReactComponent };